import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { AdminPagination } from './AdminPagination';

export const AdminCompaniesTab = ({ companies, page, setPage, pageSize, language }) => {
  const tr = language === 'tr';
  return (
    <Card className="bg-slate-900/50 border-slate-800" data-testid="admin-companies-tab">
      <CardHeader>
        <CardTitle className="text-white">{tr ? 'Şirket Listesi' : 'Company List'}</CardTitle>
        <CardDescription className="text-slate-400">
          {tr ? `Toplam ${companies.total} şirket` : `Total ${companies.total} companies`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-slate-700">
              <TableHead className="text-slate-400">{tr ? 'Şirket' : 'Company'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Sektör' : 'Industry'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Büyüklük' : 'Size'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Sahip' : 'Owner'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Değ.' : 'Assess.'}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {companies.companies.map((c) => (
              <TableRow key={c.id} className="border-slate-700">
                <TableCell className="text-white font-medium">{c.name}</TableCell>
                <TableCell className="text-slate-300 capitalize">{c.industry || 'N/A'}</TableCell>
                <TableCell className="text-slate-300 capitalize">{c.size?.replace('_', ' ') || 'N/A'}</TableCell>
                <TableCell className="text-slate-400 text-sm">{c.user_email}</TableCell>
                <TableCell className="text-slate-300">{c.assessment_count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <AdminPagination page={page} setPage={setPage} total={companies.total} pageSize={pageSize} testId="companies-pagination" />
      </CardContent>
    </Card>
  );
};
